import React, { useEffect, useState } from "react";
import { getProjectApi } from "../../api";
import config from "../../config";
import ataturk from "../../assets/ataturk.jpeg";

const About = () => {
    const [project, setProject] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchProject = async () => {
            try {
                setLoading(true);
                const result = await getProjectApi(config.project.id);
                if (result.status) {
                    setProject(result.data);
                }
            } catch (error) {
                console.error("Proje verisi yüklenirken hata:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchProject();
    }, []);

    if (loading) {
        return (
            <div className="page-text py-5 page_set">
                <div className="text-center">Yükleniyor...</div>
            </div>
        );
    }

    return (
        <div className="page-text py-5 page_set">
            <img 
                alt="Mustafa Kemal Atatürk" 
                src={ataturk} 
                width={300} 
                style={{
                    display: 'inline-block',
                    padding: '5px',
                    border: '1px solid rgb(221, 221, 221)',
                    float: 'left',
                    margin: '0px 15px 15px 0px'
                }} 
            />
            
            {project.about ? (
                <div dangerouslySetInnerHTML={{ __html: project.about }} />
            ) : (
                <div>
                    <p>İçerik yüklenemedi.</p>
                </div>
            )}
        </div>
    )
}
export default About